import { render, staticRenderFns } from "./forgot-password-page.vue?vue&type=template&id=8ce36658&"
import script from "./forgot-password-page.vue?vue&type=script&lang=js&"
export * from "./forgot-password-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports